import React from 'react';
import { Gift } from 'lucide-react';
import { bonuses } from '../data/packContents';
export const BonusShowcase = () => <div className="relative overflow-hidden rounded-sm border border-brand-gold/50 bg-brand-purpleDark px-5 py-10 md:px-10 md:py-14" data-id="element-18" data-mp="4xnyv6wz2yl5">
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-19" data-mp="iq466jwwpirv">
      <div className="absolute -top-24 left-[12%] w-[380px] h-[380px] max-w-[70vw] rounded-full bg-brand-gold/20 blur-[120px]" data-id="element-20" data-mp="dvzvpqofmsm1" />
      <div className="absolute -bottom-28 right-[10%] w-[320px] h-[320px] max-w-[70vw] rounded-full bg-brand-goldLight/15 blur-[120px]" data-id="element-21" data-mp="nn4aapa74bgc" />
      <span className="absolute -right-4 top-6 font-display text-[130px] leading-none text-brand-goldLight/[0.06] select-none" data-id="element-22" data-mp="11luawew84t9g">
        福
      </span>
    </div>

    <div className="relative text-center" data-id="element-23" data-mp="33ea02t10e5cg">
      <span className="inline-flex items-center gap-2 border border-brand-goldLight/60 text-brand-goldLight font-seal text-xs md:text-sm uppercase tracking-seal px-4 py-1.5 rounded-sm" data-id="element-24" data-mp="33f1pfm40j6ua">
        <Gift className="w-3.5 h-3.5" aria-hidden="true" data-id="element-25" data-mp="1cpbicz6iss0i" />5 bonus inclusi
      </span>

      <h3 className="mt-5 font-display font-bold text-3xl md:text-5xl leading-tight text-brand-surface" data-id="element-26" data-mp="1hmk1p33en23c">
        Tutti i bonus sono{' '}
        <span className="relative inline-block" data-id="element-27" data-mp="1mkv8t62beyhv">
          <span aria-hidden="true" className="absolute inset-x-[-6px] bottom-[0.06em] h-[0.3em] bg-brand-burgundy" data-id="element-28" data-mp="1rdoga1p64kxn" />
          <span className="relative text-brand-goldLight" data-id="element-29" data-mp="1vfjj5amqz6dj">totalmente gratis</span>
        </span>
      </h3>

      <p className="mx-auto mt-4 max-w-xl text-sm md:text-base text-brand-surface/90 leading-relaxed" data-id="element-30" data-mp="20ctgdcgdombx">
        Non sono un extra a pagamento né un upsell: sono già compresi nel tuo
        Mega Pack, senza costi aggiuntivi.
      </p>
    </div>

    <ul className="relative mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5" data-id="element-31" data-mp="2a9obrmhcu6lz">
      {bonuses.map(bonus => <li key={bonus.n} className="flex flex-col" data-id="element-32" data-mp="fxq0zg3ed2nz">
          <div className="relative overflow-hidden rounded-sm border border-brand-goldLight/40 bg-brand-paper aspect-[4/5] shadow-[0_18px_40px_-22px_rgba(0,0,0,0.9)]" data-id="element-33" data-mp="fyj8wke3dy7p">
            <img src={bonus.cover} alt={`Bonus ${bonus.n}: ${bonus.title}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-34" data-mp="2z0b8iehlfbn" />
            <span className="absolute top-2 -right-9 w-32 rotate-45 gold-gradient-bg text-brand-purpleDark text-center font-seal text-[11px] md:text-xs font-bold uppercase tracking-[0.16em] py-1 shadow-md" data-id="element-35" data-mp="hterwcakwcn5">
              Gratis
            </span>
          </div>
          <p className="mt-3 font-seal text-[11px] uppercase tracking-seal text-brand-goldLight" data-id="element-36" data-mp="lwbcg8joiitq">
            Bonus {bonus.n}
          </p>
          <p className="mt-1 font-display font-bold text-base md:text-lg leading-snug text-brand-surface" data-id="element-37" data-mp="10ntppyl5lz9e">
            {bonus.title}
          </p>
          <p className="mt-1 text-[13px] leading-snug text-brand-surface/80" data-id="element-38" data-mp="19np5kgpnmifr">
            {bonus.subtitle}
          </p>
        </li>)}
    </ul>

    <p className="relative mt-10 text-center" data-id="element-39" data-mp="15iza2sywr5vd">
      <span className="inline-block border border-brand-goldLight/50 bg-brand-purpleDark/60 px-6 py-3 rounded-sm text-sm md:text-base text-brand-surface/90" data-id="element-40" data-mp="1o94cu9zqihnf">
        5 strumenti pratici ·{' '}
        <span className="font-seal uppercase tracking-seal text-brand-goldLight" data-id="element-41" data-mp="1f97k9xa84yn3">
          €0 in più
        </span>{' '}
        rispetto al prezzo del pack
      </span>
    </p>
  </div>;